import { motion } from "framer-motion";
import { Lock } from "lucide-react";
import { STICKERS } from "@/data/stickers";

export default function StickerShelf({ progress }) {
  const owned = progress.stickers || [];

  return (
    <section id="stickers" data-testid="stickers-section" className="relative mx-auto max-w-7xl px-4 py-24 sm:px-8">
      <motion.h2
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        className="font-display text-5xl text-paper sm:text-6xl"
      >
        Magic Sticker <span className="text-candy" style={{ textShadow: "0 0 24px rgba(255,92,168,0.6)" }}>Rewards</span>
      </motion.h2>
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        className="mt-3 max-w-xl text-paper/65"
      >
        Every finished page hands you a random sticker from the jar — plus you
        can stick them right onto your artwork in the studio. Collect all ten!
      </motion.p>

      <div className="mt-12 grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-5">
        {STICKERS.map((st, i) => {
          const has = owned.includes(st.id);
          return (
            <motion.div
              key={st.id}
              data-testid={`sticker-tile-${st.id}`}
              initial={{ opacity: 0, scale: 0.85 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ delay: i * 0.05, type: "spring", stiffness: 200, damping: 16 }}
              className={`card-edge flex flex-col items-center gap-2 px-4 py-6 ${
                has ? "border-slime/40 shadow-glow-slime" : "opacity-60"
              }`}
            >
              <div className={`h-16 w-16 ${has ? "animate-floaty" : "opacity-25 grayscale"}`}>
                <svg viewBox="0 0 48 48" className="h-full w-full">{st.art}</svg>
              </div>
              <span className="text-sm font-semibold text-paper">{has ? st.name : "???"}</span>
              {!has && (
                <span className="flex items-center gap-1 text-[11px] text-paper/50">
                  <Lock size={11} /> keep coloring
                </span>
              )}
              {has && (
                <span className="text-[11px] font-bold uppercase tracking-wider text-slime">
                  earned!
                </span>
              )}
            </motion.div>
          );
        })}
      </div>
    </section>
  );
}
